// Arabisch (ar), الإعدادات · الإشعارات (0038_meldingen): zelfde vorm als pushApp.nl.ts. De server
// herkent gevoelige woorden in het Nederlands, Engels en Turks (packages/domain/src/push/
// sensitive.ts); de uitleg zegt dat eerlijk.
export const appPushAr = {
    title: 'الإشعارات',
    subtitle: 'تنبيهات صغيرة على هاتفك. أنت تختار ما يصلك.',
    settingsBody: 'التذكيرات والتوصيلات والرسائل على هاتفك',
    device: {
        title: 'على هذا الجهاز',
        on: 'الإشعارات مفعّلة على هذا الجهاز.',
        off: 'الإشعارات ما زالت متوقفة على هذا الجهاز.',
        turnOn: 'فعّل الإشعارات',
        turnOff: 'أوقفها على هذا الجهاز',
        test: 'أرسل إشعارًا تجريبيًا',
        testSent: 'أُرسل الإشعار التجريبي. سيصل بعد لحظة.',
        testNone: 'لم يُسجَّل أي هاتف بعد.',
        testOff: 'الإرسال متوقف على هذا الخادم.',
        turnedOn: 'الإشعارات مفعّلة',
        turnedOff: 'الإشعارات متوقفة على هذا الجهاز',
        denied: 'متصفحك يحظر إشعارات AMUMIN. اسمح بها من إعدادات المتصفح أو الهاتف، ثم عُد إلى هنا.',
        unsupported: 'هذا المتصفح لا يستطيع استقبال الإشعارات.',
        nativeApp: 'لا تصل الإشعارات بعد إلى تطبيق AMUMIN على iPhone. هل تريدها الآن؟ افتح AMUMIN في Safari وأضفه إلى شاشتك الرئيسية.',
        unavailable: 'لم تُضبط الإشعارات بعد. حاول مرة أخرى لاحقًا.',
        needsInstall: 'على iPhone وiPad لا تصل الإشعارات إلا إذا كان AMUMIN على شاشتك الرئيسية. أضفه هناك أولًا (انظر أدناه)، ثم افتح AMUMIN من شاشتك الرئيسية.',
        notAllowedChild: 'أحد الوالدين يفعّل الإشعارات لك.',
        inUse: 'هذا المتصفح مسجَّل بالفعل لشخص آخر في عائلتك.',
        nothingChosen: 'لم تختر شيئًا، فلن تصلك إشعارات.',
        loginNote: 'تصل الإشعارات ما دمت مسجّل الدخول على هذا الجهاز. إذا سجّلت الخروج، تتوقف.',
    },
    install: {
        title: 'ضع AMUMIN على شاشتك الرئيسية',
        body: 'عندها تفتح AMUMIN بلمسة واحدة، مثل أي تطبيق. مجانًا ودون أي تنزيل.',
        installed: 'AMUMIN على شاشتك الرئيسية.',
        platform: 'أي جهاز؟',
        ios: 'iPhone/iPad',
        android: 'Android',
        desktop: 'حاسوب',
        iosNote: 'تعمل الإشعارات بدءًا من iOS 16.4، إذا كان AMUMIN على شاشتك الرئيسية.',
        androidButton: 'ثبّت AMUMIN',
        desktopButton: 'ثبّت AMUMIN',
    },
    kinds: {
        title: 'ماذا تريد أن يصلك؟',
        autosave: 'ما تختاره يُحفظ فورًا.',
        reminders: 'تذكيراتي',
        remindersHint: 'في اللحظة نفسها التي ينادي فيها الجهاز اللوحي.',
        remindersChildren: 'وتذكيرات أطفالي أيضًا',
        rides: 'التوصيلات',
        ridesHint: '"من يوصل يعقوب غدًا الساعة 08:15؟" ومن يتولّى توصيلة.',
        approvals: 'ما ينتظر موافقتي',
        approvalsHint: 'معًا في إشعار واحد، مرة كل نصف ساعة على الأكثر.',
        messages: 'رسائل جديدة',
        departure: 'حان وقت الانطلاق',
        departureHint: 'إذا كان للموعد وقت طريق.',
        summary: 'ملخص اليوم',
        summaryHint: 'كل يوم ملخص قصير للتقويم.',
        summaryAt: 'الساعة',
    },
    quiet: {
        title: 'ساعات الهدوء',
        toggle: 'لا إشعارات في ساعات الهدوء',
        from: 'من',
        to: 'إلى',
        note: 'التذكيرات التي أنشأتها لنفسك تصل مع ذلك.',
    },
    discreet: {
        title: 'متحفّظ على شاشة القفل',
        body: 'تمر الإشعارات مشفّرة عبر خدمة Apple أو Google أو Mozilla أو Microsoft، ولا تستطيع الخدمة قراءتها. لكن أي شخص يمكنه رؤية شاشة القفل. لذلك لا يظهر افتراضيًا إلا "AMUMIN" ونوع الإشعار.',
        all: 'كل شيء متحفّظ',
        allHint: 'مفعّل افتراضيًا. ترى فقط "AMUMIN" مع "تذكير" أو "شيء عن التوصيل والإحضار" أو "شيء ينتظر موافقتك" أو "رسالة جديدة". إذا أوقفته، ترى التفاصيل: العنوان والأسماء والوقت والمكان ونص الرسالة.',
        sensitive: 'الدين والصحة والمدرسة بتحفّظ',
        sensitiveHint: 'حتى مع التفاصيل: إذا عرفنا من الرمز أو من كلمات معيّنة (بالهولندية والإنجليزية والتركية) أن الموعد أو التذكير أو الرسالة عن الصحة أو الدين أو المدرسة، يبقى الإشعار متحفّظًا. لا توجد قائمة كلمات كاملة: إن كنت مترددًا، اترك كل شيء متحفّظًا.',
    },
    children: {
        title: 'الأطفال',
        body: 'يمكن لطفل له حساب خاص أن تصله الإشعارات أيضًا، إذا وافقت. هذا متوقف افتراضيًا.',
        allow: 'إشعارات لـ {name}',
        noLogin: 'ليس لـ {name} حساب خاص.',
        none: 'لا يوجد أطفال في عائلتك بعد.',
        toastOn: 'يمكن الآن أن تصل الإشعارات إلى {name}',
        toastOff: 'لم تعد الإشعارات تصل إلى {name}',
    },
    devices: {
        title: 'هواتفك ومتصفحاتك',
        none: 'لم يُسجَّل أي هاتف أو متصفح بعد.',
        since: 'مسجَّل منذ {date}',
        lastUsed: 'آخر إشعار {date}',
        error: 'آخر إشعار لم يصل.',
        remove: 'إزالة',
        removeLabel: 'إزالة {name}',
        removed: 'أُزيل',
        thisOne: 'هذا الجهاز',
    },
    save: 'حفظ',
    saved: 'حُفظ',
    offTitle: 'الإشعارات متوقفة',
    offBody: 'الإشعارات متوقفة لعائلتك. يمكن لأحد الوالدين تفعيلها من الوحدات.',
};
//# sourceMappingURL=pushApp.ar.js.map